import { useSelector } from 'react-redux'

export const useFeatureFlag = (flagName: string, defaultValue = false) => {
  const flag = useSelector(
    (state) => state.darklyFeatureFlags?.featureFlags?.[flagName],
  )

  if (flag == null) {
    return defaultValue
  }

  return flag
}

export const useAllFeatureFlags = () => {
  return useSelector((state) => state.darklyFeatureFlags?.featureFlags ?? {})
}

interface DarklyFeatureFlags {
  readonly featureFlags?: Record<string, boolean>
}

declare module 'react-redux' {
  interface DefaultRootState {
    darklyFeatureFlags?: DarklyFeatureFlags
    auth: any
  }
}
